@for (strip of strips; track $index) {
  @if (strip.type === types.Strip) {
    <app-strip [content]="strip"></app-strip>
  }
  @if (strip.type === types.StripInfoboxes) {
    <app-strip-infobox [content]="strip"></app-strip-infobox>
  }
  @if (strip.type === types.StripImage) {
    <app-strip-image [content]="strip"></app-strip-image>
  }
}
